<!-- 尾部 -->
<template>
  <footer class="footer">
    <section class="footer__company-info" v-if="showFooterInfo">
       <div class="footer__container">
      </div>
    </section>
    <section class="footer__copyright">
      <div class="footer__container text-center">
        <span onclick="javascript:window.open('https://beian.miit.gov.cn/');">{{companyInfo.name}}</span>
      </div>
    </section>
  </footer>
</template>
<script>
  import { mapGetters } from 'vuex';
  import * as types from '../../vuex/types/type';

  export default {
    data () {
      return {
        showFooterInfo: true
      };
    },
    computed: {
      ...mapGetters({
        companyInfo: types.GET_COMPANY_INFO
      })
    },
    watch: {
      $route () {
        document.documentElement.scrollTop = document.body.scrollTop = 0;
        this.setFooterInfo();
      }
    },
    methods: {
      setFooterInfo () {
        this.showFooterInfo = ['index', 'allProducts', 'products', 'productDetails', 'aboutUs', 'factoring', 'bill', 'lease'].indexOf(this.$route.meta.name) !== -1;
      },
    },
    mounted () {
      this.setFooterInfo();
    },
  };
</script>
<style lang="scss">
  .footer {
    width: 100%;
  }

  .footer__container {
    margin: 0 auto;
    width: $containerWidth;
    position: relative;
  }
  .footer__logo{
    position: absolute;
    top:100px;
    left: 150px;
  }
  .footer__company-info {
    height: 20rem;
    overflow: hidden;
    background: url('../../../static/images/footer.png') no-repeat;
    background-size: 100% 100%;
  }

  .company-info__title {
    padding-top: 68px;
    padding-bottom: 32px;
    font-family: "Anders", Arial;
    font-size: 36px;
    text-align: center;
    color: #636059;

    &:after {
      content: '';
      display: block;
      margin: 30px auto 0;
      border: 0;
      width: 100px;
      height: 2px;
      background: $white;
    }
  }
  .company-info__content{
    width: 70%;
    margin-left: 34%;
        padding-top: 8%;
   font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
   line-height: 27px !important;
   font-size: 15px !important;
   color: #636059 !important;
  }

  .company-info__content {
    text-align: center;

    & > div {
      padding: 0 !important;
    }
  }

  #info_company {
    margin: 0 !important;
    width: 100%;
  }

  .company-info__read-more {
    display: block;
    margin: 60px auto;
    padding: 14px 35px;
    border: 1px solid #636059;
    text-align: center;
    font-family: 'MyriadPro-Regular', Arial;
    font-size: 14px;
    color: #636059;
    background: transparent;
    cursor: pointer;
  }

  .footer__friend-site {
    padding-top: 10px;
    font-family: "Dressler-Bold";
    font-size: 28px;
    background: $trueBlack;
  }

  .friend-site__label {
    display: inline-block;
    text-align:center;

    .font-white {
      color: $white * .55;
    }

    .font-waterBlue {
      color: $waterBlue * .55;
    }
  }

  .friend-site__logos {
    display: inline-block;
    @include clear;

    // for alt
    font-family: "Microsoft YaHei", Helvetica, Arial, sans-serif;
    color: $white;
    font-size: 14px;

    & a {
      position: relative;
      top: 5px;
      display: inline-block;
      height: 40px;
      margin-right: 16px;
      img {
        width: auto;
        height:29px;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }

  .footer__copyright {
    height:35px;
    line-height: 35px;
    letter-spacing: 1.5px;
    span {
      display: block;
      transform: scale(0.8);
      font-size: 12px;
    }
    color: #999999;
    background: #F7F7F7;

    .footer__container{
      margin:auto;
    }
  }
</style>



// WEBPACK FOOTER //
// Footer.vue?89c5d718